import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/pages/Home'
/* LAZY LOAD */
// MALINA
const Malina = () => Promise.resolve(require('@/components/pages/malina'))
const MalinaRooms = () => Promise.resolve(require('@/components/pages/malina/Rooms'))
const MalinaRoom = () => Promise.resolve(require('@/components/pages/malina/Room'))
const MalinaHammams = () => Promise.resolve(require('@/components/pages/malina/Hammams'))
const MalinaHammam = () => Promise.resolve(require('@/components/pages/malina/Hammam'))
const MalinaActions = () => Promise.resolve(require('@/components/pages/malina/Actions'))
// SADKO
const Sadko = () => Promise.resolve(require('@/components/pages/Sadko'))
const SadkoRooms = () => Promise.resolve(require('@/components/pages/sadko/Rooms'))
const SadkoRoom = () => Promise.resolve(require('@/components/pages/sadko/Room'))
const SadkoHammams = () => Promise.resolve(require('@/components/pages/sadko/Hammams'))
const SadkoHammam = () => Promise.resolve(require('@/components/pages/sadko/Hammam'))
const SadkoActions = () => Promise.resolve(require('@/components/pages/sadko/Actions'))
// ACROPOLIS
const Acropolis = () => Promise.resolve(require('@/components/pages/Acropolis'))
const AcropolisRooms = () => Promise.resolve(require('@/components/pages/acropolis/Rooms'))
const AcropolisRoom = () => Promise.resolve(require('@/components/pages/acropolis/Room'))
const AcropolisHammams = () => Promise.resolve(require('@/components/pages/acropolis/Hammams'))
const AcropolisHammam = () => Promise.resolve(require('@/components/pages/acropolis/Hammam'))
const AcropolisCafe = () => Promise.resolve(require('@/components/pages/acropolis/Cafe'))
const AcropolisActions = () => Promise.resolve(require('@/components/pages/acropolis/Actions'))
//
const Privacy = () => Promise.resolve(require('@/components/pages/Privacy'))

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },

    /*
     *  MALINA
     */

    {
      path: '/malina',
      name: 'malina',
      component: Malina
    },
    {
      path: '/malina/rooms',
      name: 'MalinaRooms',
      component: MalinaRooms
    },
    {
      path: '/malina/room/:id',
      props: true,
      name: 'MalinaRoom',
      component: MalinaRoom
    },
    {
      path: '/malina/hammams',
      name: 'MalinaHammams',
      component: MalinaHammams
    },
    {
      path: '/malina/hammam/:id',
      props: true,
      name: 'MalinaHammam',
      component: MalinaHammam
    },
    {
      path: '/malina/actions',
      name: 'MalinaActions',
      component: MalinaActions
    },

    /*
     *  SADKO
     */

    {
      path: '/sadko',
      name: 'sadko',
      component: Sadko
    },
    {
      path: '/sadko/rooms',
      name: 'SadkoRooms',
      component: SadkoRooms
    },
    {
      path: '/sadko/room/:id',
      props: true,
      name: 'SadkoRoom',
      component: SadkoRoom
    },
    {
      path: '/sadko/hammams',
      name: 'SadkoHammams',
      component: SadkoHammams
    },
    {
      path: '/sadko/hammam/:id',
      props: true,
      name: 'SadkoHammam',
      component: SadkoHammam
    },
    {
      path: '/sadko/actions',
      name: 'SadkoActions',
      component: SadkoActions
    },

    /*
     *  ACROPOLIS
     */

    {
      path: '/acropolis',
      name: 'acropolis',
      component: Acropolis
    },
    {
      path: '/acropolis/rooms',
      name: 'AcropolisRooms',
      component: AcropolisRooms
    },
    {
      path: '/acropolis/room/:id',
      props: true,
      name: 'AcropolisRoom',
      component: AcropolisRoom
    },
    {
      path: '/acropolis/hammams',
      name: 'AcropolisHammams',
      component: AcropolisHammams
    },
    {
      path: '/acropolis/hammam/:id',
      props: true,
      name: 'AcropolisHammam',
      component: AcropolisHammam
    },
    {
      path: '/acropolis/cafe',
      name: 'AcropolisCafe',
      component: AcropolisCafe
    },
    {
      path: '/acropolis/actions',
      name: 'AcropolisActions',
      component: AcropolisActions
    },

    /*
     * ALL
     */

    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    }
  ],
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    }
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js